export default __webpack_public_path__ + "static/media/parc3.e2723757.png";